import { X, MapPin, Upload, HelpCircle, Bell } from "lucide-react";
import { Avatar, AvatarFallback } from "../ui/avatar";
import { useState } from "react";
import { useToast } from "../../hooks/use-toast";






const profileData = {
  1: { name: "Leyla Mammadova", initials: "LM", uni: "Baku State University", major: "Computer Science", bio: "CS student, love algorithms and competitive programming. Always happy to help!", followers: 234, following: 89, uploads: 18 },
  2: { name: "Rashad Huseynov", initials: "RH", uni: "ADA University", major: "Computer Science", bio: "Full-stack developer in training. Building cool things with React and Node.", followers: 156, following: 67, uploads: 12 },
  3: { name: "Nigar Aliyeva", initials: "NA", uni: "Baku Engineering University", major: "Engineering", bio: "Studying electrical engineering. Interested in IoT and embedded systems.", followers: 98, following: 45, uploads: 8 },
  4: { name: "Student Affairs Office", initials: "SA", uni: "Baku State University", major: "Administration", bio: "Official account for university announcements and student services.", followers: 1200, following: 0, uploads: 45 }
};

const ProfileCard = ({ profileId, onClose }) => {
  const profile = profileData[profileId] || profileData[1];
  const [isFollowing, setIsFollowing] = useState(false);
  const [notifyUploads, setNotifyUploads] = useState(false);
  const [notifyAnswers, setNotifyAnswers] = useState(false);
  const [showNotifyOptions, setShowNotifyOptions] = useState(false);
  const { toast } = useToast();

  const handleFollow = () => {
    setIsFollowing(!isFollowing);
    if (!isFollowing) {
      setShowNotifyOptions(true);
      toast({ title: `You are now following ${profile.name}` });
    } else {
      setShowNotifyOptions(false);
      toast({ title: `Unfollowed ${profile.name}` });
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="absolute inset-0 bg-foreground/40 backdrop-blur-sm" />
      <div className="relative bg-card rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden animate-fade-in" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="h-20 bg-gradient-to-r from-primary to-primary/60" />
        <button onClick={onClose} className="absolute top-3 right-3 w-8 h-8 rounded-xl bg-card/80 backdrop-blur-sm hover:bg-card flex items-center justify-center transition-colors">
          <X className="w-4 h-4" />
        </button>

        <div className="px-5 pb-5">
          {/* Avatar */}
          <div className="-mt-8 mb-3">
            <Avatar className="w-16 h-16 border-4 border-card">
              <AvatarFallback className="bg-secondary text-secondary-foreground text-xl font-bold">{profile.initials}</AvatarFallback>
            </Avatar>
          </div>

          <h3 className="text-lg font-display font-bold text-foreground">{profile.name}</h3>
          <p className="text-sm text-muted-foreground flex items-center gap-1.5 mt-0.5">
            <MapPin className="w-3 h-3" /> {profile.uni} · {profile.major}
          </p>
          <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{profile.bio}</p>

          {/* Stats */}
          <div className="flex items-center gap-4 mt-3 py-3 border-t border-b border-border">
            <div className="text-center flex-1">
              <p className="text-lg font-display font-bold text-foreground">{profile.followers}</p>
              <p className="text-[10px] text-muted-foreground">Followers</p>
            </div>
            <div className="text-center flex-1">
              <p className="text-lg font-display font-bold text-foreground">{profile.following}</p>
              <p className="text-[10px] text-muted-foreground">Following</p>
            </div>
            <div className="text-center flex-1">
              <p className="text-lg font-display font-bold text-foreground">{profile.uploads}</p>
              <p className="text-[10px] text-muted-foreground">Uploads</p>
            </div>
          </div>

          {/* Actions */}
          <div className="flex gap-2 mt-4">
            <button onClick={handleFollow}
            className={`flex-1 h-10 rounded-2xl text-sm font-semibold transition-colors ${
            isFollowing ? "bg-secondary text-secondary-foreground" : "bg-primary text-primary-foreground hover:bg-primary/90"}`
            }>
              {isFollowing ? "Following" : "Follow"}
            </button>
            <button className="flex-1 h-10 rounded-2xl border border-border text-sm font-medium text-foreground hover:bg-muted transition-colors">
              Friend Request
            </button>
          </div>

          {/* Notification options (shown after follow) */}
          {showNotifyOptions && isFollowing &&
          <div className="mt-3 p-3 rounded-xl bg-muted/50 animate-fade-in">
              <p className="text-xs font-medium text-foreground mb-2 flex items-center gap-1.5">
                <Bell className="w-3.5 h-3.5 text-secondary" /> Notify me about:
              </p>
              <div className="space-y-2">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={notifyUploads} onChange={() => setNotifyUploads(!notifyUploads)}
                className="w-3.5 h-3.5 rounded border-border accent-secondary" />
                
                  <Upload className="w-3 h-3 text-muted-foreground" />
                  <span className="text-xs text-foreground">Uploads</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={notifyAnswers} onChange={() => setNotifyAnswers(!notifyAnswers)}
                className="w-3.5 h-3.5 rounded border-border accent-secondary" />
                
                  <HelpCircle className="w-3 h-3 text-muted-foreground" />
                  <span className="text-xs text-foreground">Questions answered</span>
                </label>
              </div>
            </div>
          }
        </div>
      </div>
    </div>);

};

export default ProfileCard;